<template>
<div class="map-wrap">
	<div class="map" ref="mapContainer"></div>

	<map-context-menu
		:position="mapContextMenuPosition"
		:visible="mapContextMenuVisible"
		:items="mapContextMenuItems"
		@itemClick="handleMapContextMenuItemClick"
	/>

	<div class="row row-cols-1 justify-content-start m-0 ms-2 mt-2">
		<!-- Update time -->
		<div
			class="col p-0 px-1 m-0 map-header-left-text"
			ref="connection"
		>
			<!-- Останнє оновлення  -->
			<div
				v-if="updateTimeString() == null"
				class="spinner-border spinner-border-sm text-dark" role="status"
			>
				<span class="visually-hidden">Loading...</span>
			</div>
			<span
				data-bs-toggle="tooltip"
				data-bs-placement="bottom"
				data-bs-title="час останнього оновлення мапи"
				class="fw-bold text-decoration-underline"
			>
				{{ updateTimeString() }}
			</span>
		</div>
	</div>

	<div class="row row-cols-1 justify-content-start m-0">
		<!-- Map style schema button -->
		<div class="col-auto m-0 mt-2 ms-2 p-0 map-header-btn-block">
			<button
				class="btn btn-sm btn-light btn-on-map p-0 px-1"
				style="width: 33px; height: 33px;"
				title="Схема"
				@click.stop="setMapStyleStreet()"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="currentColor"
					class="bi bi-map"
					viewBox="0 0 16 16"
				>
					<path fill-rule="evenodd" d="M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.5.5 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103M10 1.91l-4-.8v12.98l4 .8zm1 12.98 4-.8V1.11l-4 .8zm-6-.8V1.11l-4 .8v12.98z"/>
				</svg>
			</button>
		</div>
	</div>

	<div class="row row-cols-1 justify-content-start m-0">
		<!-- Map style satellite button -->
		<div class="col-auto m-0 mt-2 ms-2 p-0 map-header-btn-block">
			<button
				class="btn btn-sm btn-light btn-on-map p-0 px-1"
				style="width: 33px; height: 33px;"
				title="Супутник"
				@click.stop="setMapStyleHybrid()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" version="1.1" class="si-glyph si-glyph-satellite">
					<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g fill="#434343">
							<path d="M12.495,5.893 C12.832,6.231 14.184,4.877 13.847,4.541 L10.864,1.557 C10.526,1.219 9.174,2.573 9.51,2.909 L12.495,5.893 L12.495,5.893 Z" class="si-glyph-fill">
							</path>
							<path d="M3.288,10.897 C3.072,10.68 2.597,10.802 2.23,11.168 C1.863,11.536 1.742,12.009 1.959,12.228 L3.233,13.501 C3.45,13.719 3.922,13.597 4.289,13.23 C4.658,12.864 4.779,12.388 4.562,12.172 L3.288,10.897 L3.288,10.897 Z" class="si-glyph-fill">
							</path>
							<rect transform="translate(2.240100, 2.131300) rotate(-44.991897) translate(-2.240100, -2.131300) " x="-0.25987605" y="1.13130958" width="4.96295245" height="1.95398128" class="si-glyph-fill">
							</rect>
							<path d="M12.088,8.374 L10.657,9.802 L9.918,9.063 L11.543,7.439 C11.814,7.168 11.81,6.723 11.531,6.447 L9.031,3.948 C8.757,3.673 8.314,3.67 8.043,3.939 L6.419,5.564 L5.684,4.829 L7.113,3.401 L5.718,2.007 L2.221,5.503 L3.614,6.897 L5.028,5.484 L5.763,6.219 L4.134,7.849 C3.864,8.12 3.866,8.564 4.141,8.838 L6.641,11.336 C6.917,11.612 7.363,11.617 7.632,11.346 L9.262,9.717 L10.001,10.456 L8.585,11.869 L9.967,13.25 L13.464,9.753 L12.088,8.374 L12.088,8.374 Z" class="si-glyph-fill">
							</path>
							<rect transform="translate(13.426200, 12.673100) rotate(-45.056720) translate(-13.426200, -12.673100) " x="10.9262228" y="11.6731091" width="4.96795479" height="1.97998198" class="si-glyph-fill">
							</rect>
						</g>
					</g>
				</svg>
			</button>
		</div>
	</div>

	<div
		v-if="accountStore.permissions.includes('manage_organizations')"
		class="row row-cols-1 justify-content-start m-0 mt-5"
	>
		<!-- Save start location button -->
		<div class="col-auto m-0 mt-2 ms-2 p-0 map-header-btn-block">
			<button
				class="btn btn-sm btn-light btn-on-map p-0 px-1"
				:style="{width: $options.buttonEdgeLen, height: $options.buttonEdgeLen,}"
				title="Зберегти локацію по замовчуванню для організації"
				@click.stop="startLocationConfirmationPopup=true"
			>
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" version="1.1" class="si-glyph si-glyph-satellite">
					<path d="M12 2h-2v3h2z"/>
					<path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5V2.914a1.5 1.5 0 0 0-.44-1.06L14.147.439A1.5 1.5 0 0 0 13.086 0zM4 6a1 1 0 0 1-1-1V1h10v4a1 1 0 0 1-1 1zM3 9h10a1 1 0 0 1 1 1v5H2v-5a1 1 0 0 1 1-1"/>
				</svg>
			</button>
		</div>

		<!-- Start location confirmation popup -->
		<confirmation-popup
			v-model:show="startLocationConfirmationPopup"
			@confirm="saveStartLocation()"
		>
			<template v-slot:body>
				<p>
					Ви впевнені що хочете зберегти поточну локацію як локацію по замовчуванню при відкритті мапи для всіх користувачів організації?
				</p>
			</template>
		</confirmation-popup>

		<!-- Station location confirmation popup -->
		<confirmation-popup
			title="Результат запиту"
			confirmButtonTitle="Зрозуміло"
			rejectButtonTitle=""
			v-model:show="saveLocationResultPopup"
		>
			<template v-slot:body>
				<p :class="{'text-danger': !saveLocationResult}">
					{{ saveLocationResultPromt }}
				</p>
			</template>
		</confirmation-popup>
	</div>
	
	<stations-layer
		v-if="isShowStations"
		:map="map"
		:mapContainerEl="$refs.mapContainer"
		:stations="showingStations"
	/>

	<posts-layer
		v-if="isShowPosts"
		:map="map"
		:mapContainerEl="$refs.mapContainer"
		:posts="showingPosts"
	/>
</div>
</template>


<script>
import {
	Map,
	MapStyle,
	config,
	geolocation,
} from '@maptiler/sdk'
import { GeocodingControl } from "@maptiler/geocoding-control/maptilersdk"
import '@maptiler/sdk/dist/maptiler-sdk.css'
import "@maptiler/geocoding-control/style.css"
import { shallowRef, markRaw } from 'vue'
import { useTooltip } from '@/composables/bootstrap-tooltip.js'
import { RESOURCE_NAMES, updateResourceItem } from '@/api/api'
import { Station } from '@/models/station.js'
import { Post } from '@/models/post'
import { useStationsStore } from '@/stores/StationsStore'
import { usePostsStore } from '@/stores/PostsStore'
import { useAccontStore } from '@/stores/AccountStore'
import ConfirmationPopup from '../ConfirmationPopup.vue'
import { dateTimeToString, dateTimeToTimeString } from "@/helpers"
import MapContextMenu from "@/components/MapView/MapContextMenu"
import StationsLayer from './StationsLayer.vue'
import PostsLayer from './PostsLayer.vue'

export default {
	inject: ['headerHeight'],
	buttonEdgeLen: "33px",

	components: {
		MapContextMenu,
		ConfirmationPopup,
		StationsLayer,
		PostsLayer,
	},

	setup() {
		const stationsStore = useStationsStore()
		const postsStore = usePostsStore()
		const accountStore = useAccontStore()
		const mapContainer = shallowRef()
		const map = shallowRef()

		useTooltip()

		return {
			stationsStore,
			postsStore,
			accountStore,
			mapContainer,
			map,
		}
	},

	data() {
		return {
			tooltips: [],

			// Stations update period
			metrics_update_rate: 10000,
			updateInterval: null,
			updateTime: null,

			// Map context menu
			mapContextMenuVisible: false,
			mapContextMenuPosition: { top: 0, left: 0 },
			mapContextMenuItems: [],

			// Stations
			isShowStations: false,
			showingStations: [],
			
			// Posts
			isShowPosts: false,
			showingPosts: [],

			// Popups
			// Confirm update
			startLocationConfirmationPopup: false,
			// Update result
			saveLocationResult: null,
			saveLocationResultPopup: false,
			saveLocationResultPromt: "",
		}
	},

	async created() {
	},

	async mounted() {
		document.title = "Мапа"

		if (this.stationsStore.isNoStations) {
			await this.stationsStore.readStations()
		}

		if (this.postsStore.isNoPosts) {
			await this.postsStore.readPosts()
		}
		
		await this.updateStations()
		await this.updatePosts()
		await this.initMap()
		this.subscribeToUpdates()

		this.isShowStations = true
		this.isShowPosts = true
	},

	methods: {
		async initMap() {
			config.apiKey = this.accountStore.organization[this.accountStore.schema.organization.mapApiKey]
			const startLocation = this.accountStore.organization?.map?.start_location
			const startZoom = this.accountStore.organization?.map?.start_zoom

			//console.log("HASH", this.$route.query.style)
			const stylesMap = {
				undefined: MapStyle.STREETS,
				"streets": MapStyle.STREETS,
				"hybrid": MapStyle.HYBRID,
			}

			const initialState = {
				style: stylesMap[this.$route.query.style],
				lng: startLocation == undefined ? 31.50627254560835 : startLocation.coordinates[0],
				lat: startLocation == undefined ? 49.38220262039323 : startLocation.coordinates[1],
				zoom: startZoom == undefined ? 6 : startZoom
			}

			this.map = markRaw(new Map({
				container: this.mapContainer,
				style: initialState.style,
				center: [initialState.lng, initialState.lat],
				zoom: initialState.zoom,
				scaleControl: true,
				hash: true,
			}))

			// Set map language based on user IP location
			const geolocationIP = await geolocation.info()
			const {country_languages} = geolocationIP
			this.map.setLanguage(`name:${country_languages[0]}`)

			// Add search street input field
			// If user has manage stations permission
			//if (this.accountStore.permissions.includes('manage_stations')) {
				const gc = new GeocodingControl()
				this.map.addControl(gc, 'top-right')
			//}

			// Map events handlers
			//
			// The `click` event
			this.map.on('click', function() {
				this.hideMapContextMenu()
			}.bind(this))

			// Right button click
			this.map.on('contextmenu', function(e) {
				//console.log('A click event has occurred at ', e)
				this.showMapContextMenu(e)
			}.bind(this))

			// Drag map
			this.map.on('drag', function() {
				this.hideMapContextMenu()
			}.bind(this))

			// Zoom map
			this.map.on('zoomstart', function() {
				this.hideMapContextMenu()
			}.bind(this))
		},

		subscribeToUpdates() {
			// Clear interval if exist
			if (this.updateInterval !== null) {
				clearInterval(this.updateInterval)
				this.updateInterval = null
			}

			// Updates metrics and alerts every metrics_update_rate seconds
			this.updateInterval = setInterval(async () => {
				await this.updateStations()
				await this.updatePosts()
			}, this.metrics_update_rate)
		},

		async updateStations() {
			let isReadMetrics = null
			//console.log("update stations")
			await this.stationsStore.readMetrics((result) => {
				isReadMetrics = result
				if (!result) {
					console.error("on read stations metrics")
				}
			})

			if (isReadMetrics == true) {
				this.updateTime = new Date()
			}

			this.showingStations = this.stationsWithLocation
		},

		async updatePosts() {
			let isReadMetrics = null
			//console.log("update posts")
			await this.postsStore.readMetrics((result) => {
				isReadMetrics = result
				if (!result) {
					console.error("on read posts metrics")
				}
			})

			//console.log("Update metrics result: ", isReadMetrics)
			if (isReadMetrics == true) {
				this.updateTime = new Date()
				//console.log("Update time ", this.updateTime, "posts: ", this.postsWithLocation)
			}

			this.showingPosts = this.postsWithLocation
			//console.log("Posts on map", this.showingPosts)
		},

		updateTimeString() {
			const now = new Date()

			if (this.updateTime == null) {
				return null
			}

			if (now.getDay() == this.updateTime.getDay()) {
				return dateTimeToTimeString(this.updateTime)
			} else {
				return dateTimeToString(this.updateTime)
			}
		},

		showMapContextMenu(event) {
			//console.log("event ", event)
			event.preventDefault()

			this.hideMapContextMenu()

			this.mapContextMenuItems.length = 0
			this.stationsWithoutLocation.forEach(station => {
				const nodeName = station.shortName ? station.shortName : station.name
				this.mapContextMenuItems.push({
					id: station.id,
					type: 'станція',
					title: nodeName,
					location: event.lngLat
				})
			})

			this.postsWithoutLocation.forEach(post => {
				const nodeName = post.shortName ? post.shortName : post.name
				this.mapContextMenuItems.push({
					id: post.id,
					type: 'КВП',
					title: nodeName,
					location: event.lngLat
				})
			})

			this.mapContextMenuVisible = true
			this.mapContextMenuPosition = { top: event.point.y, left: event.point.x }
		},

		handleMapContextMenuItemClick(item) {
			//console.log(`Ви вибрали: `, item.title)
			switch(item.type){
				case "станція":
					this.saveStationLocation(item.id, item.location)
					break
				case "КВП":
					this.savePostLocation(item.id, item.location)
					break
			}

			this.hideMapContextMenu()
		},

		async saveStationLocation(stationId, location) {
			//console.log('Save location of station ' + stationId, location)
			const station = this.stationsStore.station(stationId)
			if (station === undefined) {
				console.error(`Cant't find station ${stationId}`)
				return
			}

			let payload = {}
			station.setLocation(location.lat, location.lng)
			payload[Station.passportKeys.location] = station.passport.get(Station.passportKeys.location)
			//console.log("Location payload", payload)

			this.stationsStore.updatePasport(async (result) => {
				if (result) {
					await this.updateStations()
				} else {
					console.error("Station passport update error")
				}
			}, stationId, payload)
		},

		async savePostLocation(postId, location) {
			//console.log('Save location of post ' + postId, location)
			const post = this.postsStore.post(postId)
			if (post === undefined) {
				console.error(`Cant't find post ${postId}`)
				return
			}

			let payload = {}
			post.setLocation(location.lat, location.lng)
			payload[Post.passportKeys.location] = post.passport.get(Post.passportKeys.location)
			//console.log("Location payload", payload)

			this.postsStore.updatePasport(async (result) => {
				if (result) {
					await this.updatePosts()
				} else {
					console.error("Post passport update error")
				}
			}, postId, payload)
		},

		hideMapContextMenu() {
			this.mapContextMenuVisible = false
		},

		setMapStyleStreet() { this._setMapStyle('streets') },

		setMapStyleHybrid() { this._setMapStyle('hybrid') },

		_setMapStyle(style) {
			if (this.$route.query.style === style)
				return
			this.$router.push( { name: 'map', query: { style: style }, hash: window.location.hash, replace: true } )
			setTimeout(() => {this.$router.go(0)}, 10)
		},

		saveStartLocation() {
			const payload = {
				map: {
					start_location: {
						'type': 'Point',
						'coordinates': [this.map.getCenter().lng, this.map.getCenter().lat],
					},
					start_zoom: this.map.getZoom(),
				}
			}
			//console.log("payload = ", payload)

			// Request server to update account
			updateResourceItem(
				RESOURCE_NAMES.organizations,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
				this.accountStore.organization._id,
				this.accountStore.organization._etag,
				payload
			).then(result => {
				//jconsole.log("Result ", result)
				this.accountStore.organization._etag = result._etag
				this.accountStore.organization._updated = result._updated

				if (result._status == 'OK') {
					this.saveLocationResult = true
					this.saveLocationResultPromt = "Стартові координати збережено успішно!"
				} else {
					this.saveLocationResult = false
					this.saveLocationResultPromt = "Сталася помилка! Стартові координати не збережено."
				}

				this.saveLocationResultPopup = true
			}).catch(err => {
				console.error("on update organization start coordinates", err)
			})
		},
	},


	computed: {
		stationsWithLocation() {
			return this.stationsStore.stationsArray.filter(station => {
				const location = station.passport.get(Station.passportKeys.location)
				return station.isActive &&
					location !== undefined &&
					location.coordinates[0] != 0 &&
					location.coordinates[1] != 0
			})
		},

		stationsWithoutLocation() {
			return this.stationsStore.stationsArray.filter(station => {
				const location = station.passport.get(Station.passportKeys.location)
				return station.isActive &&
					(location === undefined ||
					(location !== undefined &&
					location.coordinates[0] == 0 &&
					location.coordinates[1] == 0))
			})
		},

		postsWithLocation() {
			return this.postsStore.postsArray.filter(post => {
				const location = post.passport.get(Post.passportKeys.location)
				return post.isActive &&
					location !== undefined &&
					location.coordinates[0] != 0 &&
					location.coordinates[1] != 0
			})
		},

		postsWithoutLocation() {
			return this.postsStore.postsArray.filter(post => {
				const location = post.passport.get(Post.passportKeys.location)
				return post.isActive &&
					(location === undefined ||
					(location !== undefined &&
					location.coordinates[0] == 0 &&
					location.coordinates[1] == 0))
			})
		},
	},

	beforeUnmount() {
		if (this.updateInterval != null) {
			clearInterval(this.updateInterval)
			this.updateInterval = null
		}
	},

	unmounted() {
		this.map?.remove()
	},
}
</script>


<style scoped>
.map-wrap {
	position: relative;
	
	width: 100%;
	height: calc(100vh - v-bind(headerHeight));

	overflow-x: hidden;
	overflow-y: hidden;
}

.map {
	position: absolute;

	width: calc(100% - 4px);
	height: calc(100% - 4px);
	margin: 2px;
	margin-top: 1px;

	overflow-x: hidden;
	overflow-y: hidden;
}

.map-header-left-text {
	position: relative;
	z-index: 1;
	right: 0;
	width:fit-content;

	display: inline-block;
	background-color:rgba(255, 255, 255, 0.5);
	/* border-radius: 0.375rem; */
}

.map-header-btn-block {
	position: relative;
	z-index: 1;
	display: inline-block;
	/* width: fit-content; */
}

.btn-on-map:hover svg path,
.btn-on-map:hover svg rect {
  fill: #0a58ca
}
</style>